// The root route. Deliberately thin: it renders the shell column and an
// <Outlet>, and nothing else.
//
// It has no auth guard. The guard lives on the `_app` pathless layout route so
// that `/login` — which must render when there is no session — is not itself
// behind it.
import { createRootRoute, Outlet } from '@tanstack/react-router';

function RootLayout() {
  return (
    // A centred column capped at 880px with hairline side rules — the app is
    // phone/tablet-first, and on a laptop the column simply stops growing
    // rather than sprawling. Plain stock utilities; the previous bespoke
    // `shell` utility was removed with the Industry design system.
    //
    // Deliberately `min-h-dvh`, not `h-dvh`: this root is shared by routes
    // that must NOT be height-capped here — the print report and login both
    // render outside AppShell and rely on natural document growth/scroll.
    // AppShell instead height-constrains its OWN column (`h-dvh` there) so
    // its content region scrolls internally without capping this ancestor —
    // see components/shell/app-shell.tsx.
    <div className="text-foreground mx-auto min-h-dvh w-full max-w-[880px] border-x">
      <Outlet />
    </div>
  );
}

export const Route = createRootRoute({
  component: RootLayout
});
